import React, { Component } from 'react';
import muiThemeable from 'material-ui/styles/muiThemeable';
import {Headline, Subheading} from './Typography';

const Testimonial = muiThemeable()((props) => (
  <div>
    <Headline style={{width: '600px', maxWidth: '90%', margin: 'auto'}}>&quot;{props.headline}&quot;</Headline>

     { props.quote && props.attribution &&
       <div style={{width: "600px", maxWidth: "95%",
                    margin: "2em auto 2em auto",
                    boxShadow: "0px 0px 2px #d9d9d9",
                    textAlign: "left",
                    padding: "2.5%" }}>
          <div style={{
              color: props.muiTheme.palette.lightTextColor,
              fontSize: "16px",
              marginBottom: "0.5em",
            }}>
           {props.quote}
          </div>
         <Subheading>&mdash;{props.attribution}</Subheading>
       </div>
     }
  </div>
))

const Divider = (props) => (
  <hr style={{ margin: "2em auto",
               display: "block",
               borderTop: "1px solid #d9d9d9",
                width: "33%" }}
           />
)

class TestimonialSection_ extends Component {
  constructor(props) {
    super(props);

    this.style = {
      backgroundColor: this.props.muiTheme.palette.canvasColor,
      color: this.props.muiTheme.palette.textColor,
      paddingTop: "40px",
      paddingBottom: "40px",
      fontFamily: this.props.muiTheme.fontFamily,
      textAlign: 'center',
      //maxWidth: '1200px',
      //margin: 'auto',
    }
  }

  render() {
    return (
      <div style={this.style}>
        <Headline style={{width: '600px', maxWidth: '90%', margin: 'auto'}}>Home Gallery Project will have you saying things like:</Headline>
        <Divider />
        {this.props.children}
      </div>
    )
  }
}

const TestimonialSection = muiThemeable()(TestimonialSection_);

export { TestimonialSection, Testimonial, Divider };



// WEBPACK FOOTER //
// ./src/TestimonialSection.js